export enum PasswordSecurity {
	BASIC = 1,
	STRONG = 2
}
